module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iyWpR"))).then(() => module.bundle.root('cvs7o'));